import { gql } from '@apollo/client';

export const CORE_JOB_FIELDS = gql`
  fragment CoreJobFields on Job {
    _id
    pdfUrl
    jobDescription
    jobDescriptionStatus
    jobDescriptionError
    questions
    interviewQuestions
    title
    published
    comment
    hideClientName
    candidatesStats {
      total
      withQuestionnaire
      withQuestionnairePassed
      filteredOut
      finished
      firstApplicationDate
      lastApplicationDate
      maxScore
      averageScore
      conversionRate
    }
    # applications {
    #   _id
    #   stage
    #   user {
    #     _id
    #     firstName
    #     lastName
    #     email
    #     avatarUrl
    #   }
    #   talent {
    #     _id
    #     linkedin
    #     pdfUrl
    #   }
    #   interview {
    #     _id
    #     isFinished
    #     durations
    #     recording {
    #       _id
    #       state
    #     }
    #   }
    #   questionnaire {
    #     _id
    #     passed
    #     questions
    #     answers
    #   }
    #   evaluation
    #   updatedAt
    # }
    # allApplications {
    #   _id
    #   stage
    #   questionnaire {
    #     _id
    #     passed
    #   }
    #   evaluationStatus
    #   updatedAt
    # }
    # position {
    #   _id
    #   name
    # }
    # experience
    hasJobDescription
    atsTargetStageId
    atsSourceStageId
    greenhouseFlowMode
    ashbyFlowMode
    # salesCount
    # industries
    # businesses
    # products
    # budget {
    #   from
    #   to
    # }
    # commissions {
    #   value
    #   unit
    #   type
    #   quantity
    # }
    # dealSize { from to }
    # contractCycle
    comment
    # level
    # skills
    # engagement
    # startTime
    # endTime
    # closed
    createdAt
  }
`;
